import { Store } from '@ngrx/store';
import { Observable, combineLatest, switchMap } from 'rxjs';

import { ProductUid } from '../../domain/models/related-products.models';

import { getCampaignUseCase } from './get-campaign.use-case';

import { ApplicationSections, ApplicationSectionsNumber } from '@core/domain/models/application-section.model';
import { getStoreId } from '@core/infrastructure/state/core.selectors';
import { ProductPublicModels } from '@features/products/product';
import {
    RelatedProductsRepositoryInterface,
} from '@shared/product/related-products/domain/related-products-repository.interface';

export const getCompleteLookYodaProductsUseCase = (
    relatedProductsRepository: RelatedProductsRepositoryInterface,
    store: Store,
    baseProduct: ProductPublicModels.PublicProduct,
    section: number,
): Observable<ProductUid[]> => {
    // TO REFACTOR: Get the store details as a parameter would reduce the coupling and complexity of this function
    return combineLatest([
        getCampaignUseCase(store, baseProduct),
        store.select(getStoreId),
    ]).pipe(
        switchMap(([campaign, marketId]) => {
            const sectionName = ApplicationSectionsNumber[section] || ApplicationSections.WOMEN;

            return relatedProductsRepository.getCompleteLookYoda$(
                campaign,
                baseProduct.id,
                sectionName,
                marketId,
            );
        })
    );
};
